import React from 'react';
import FollowButton from './Follow/FollowButton';
import BusinessCard from '../../core/Businesses/BusinessCard/BusinessCard';
import type { BusinessCardProps } from '../../core/Businesses/BusinessCard/BusinessCard';

type CardProps = BusinessCardProps & {
  id: number,
  followerCount: number,
  isFollowing: boolean,
  isAuthenticated: boolean,
  isRecent: boolean,
  onChange: React.MouseEventHandler,
};

const Card = ({
  id,
  name,
  followerCount,
  isAuthenticated,
  isFollowing,
  isRecent,
  // デフォルトでは、フォローボタンを表示する
  isShowFollowButton = true,
  onChange,
  ...cardProps
}: CardProps) => {
  return (
    <BusinessCard
      {...cardProps}
      isRecent={isRecent}
      name={name}
      mediaButton={
        isShowFollowButton && (
          <FollowButton
            businessId={id}
            businessName={name}
            buttonType="rounded"
            followerCount={followerCount}
            isFollowerShown
            isAuthenticated={isAuthenticated}
            isFollowing={isFollowing}
            onChange={onChange}
          />
        )
      }
    />
  );
};

export default Card;
